import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const Container = styled.div`
  gap: ${themeGet('space.2')}px;
  font-size: ${themeGet('fontSizes.2')}px;
  flex-wrap: wrap;

  b {
    display: inline;
    color: ${themeGet('colors.primary.main')};
    white-space: nowrap;
  }

  p,
  ol,
  ul {
    margin: 0 !important;
  }

  a {
    text-decoration: none;
    color: ${themeGet('colors.primary.main')};
    font-weight: ${themeGet('fontWeights.1')};

    &:hover {
      color: ${themeGet('colors.primary.dark')};
    }
  }
`
